export class SetEnvironment {
  environment;
  static type = '[AppEnvironmentState] Set Environment';
  constructor(environment) {
    this.environment = environment;
  }
}
